import { render, staticRenderFns } from "./ConfirmDeleteContact.vue?vue&type=template&id=e0c6f700&"
import script from "./ConfirmDeleteContact.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports